export default __webpack_public_path__ + "static/media/blackFront2.ef647b06.png";